import { render, staticRenderFns } from "./FlexSeparator.vue?vue&type=template&id=30601ef4&"
import script from "./FlexSeparator.vue?vue&type=script&lang=js&"
export * from "./FlexSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports